import { dispatch } from '@/modules/event'

const state = {
  breakpoints: [],
  breakpoint: '',
  windowWidth: 0,
  device: ''
}

const getters = {
  getBreakpoints: state => state.breakpoints,
  getBreakpoint: state => state.breakpoint,
  getWindowWidth: state => state.windowWidth,
  getDevice: state => state.device
}

const mutations = {
  UPDATE_BREAKPOINTS: (state, array) => {
    state.breakpoints = [ ...array ]
  },
  UPDATE_BREAKPOINT: (state, string) => {
    state.breakpoint = string
  },
  UPDATE_WINDOW_WIDTH: (state, number) => {
    state.windowWidth = number
  },
  UPDATE_DEVICE: (state, string) => {
    state.device = string
  }
}

const actions = {
  updateBreakpoints: (store, breakpoints) => {
    store.commit('UPDATE_BREAKPOINTS', breakpoints)
  },
  updateBreakpoint: (store, breakpoint) => {
    store.commit('UPDATE_BREAKPOINT', breakpoint)
  },
  updateWindowWidth: (store, width) => {
    if (width !== store.getters.getWindowWidth) {
      store.commit('UPDATE_WINDOW_WIDTH', width)
      store.getters.getBreakpoints.forEach(mediaquery => {
        if (width >= mediaquery.min && width <= mediaquery.max) {
          store.dispatch('updateBreakpoint', mediaquery.name)
          store.dispatch('updateDevice', mediaquery.name)
          dispatch(window, 'breakpoints.change', {
            name: store.getters.getBreakpoint
          })
        }
      })
    }
  },
  updateDevice: (store, breakpoint) => {
    if (breakpoint === 'small') store.commit('UPDATE_DEVICE', 'mobile')
    else if (breakpoint === 'medium') store.commit('UPDATE_DEVICE', 'tablet')
    else store.commit('UPDATE_DEVICE', 'desktop')
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
